import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import moment from 'moment';

export default class DateTimePickerMonths extends Component {
  renderMonths = () => {
    let i, month, months, monthsShort;
    month = this.props.selectedDate.month();
    monthsShort = moment.monthsShort();
    i = 0;
    months = [];

    const monthsVerbose = moment.months();

    while (i < 12) {
      let monthInYear = this.props.viewDate.clone().month(i);

      let monthBeforeMinDate = this.props?.minDate
        ? monthInYear.isBefore(this.props.minDate, 'month')
        : false;
      let monthAfterMaxDate = this.props?.maxDate
        ? monthInYear.isAfter(this.props.maxDate, 'month')
        : false;
      let disabled = monthBeforeMinDate || monthAfterMaxDate;

      let classes = {
        month: true,
        active:
          i === month &&
          this.props.viewDate.year() === this.props.selectedDate.year(),
        // disabled // This will disable cells that are below the min date or above the max date, and make them disabled. Possibly going too far to enable this
      };
      const tabIndex = disabled ? undefined : 0;
      months.push(
        <span>
          <span
            className={classnames(classes)}
            key={i}
            onClick={this.props.setViewMonth}
            // aria-hidden={true}
            tabIndex={tabIndex}
            data-test-id="datepicker-month--cell"
          >
            {monthsShort[i]}
          </span>
          <span className="sr-only" key={`sr-month-${i}`}>
            {monthsVerbose[i]}
          </span>
        </span>
      );
      i++;
    }
    return months;
  };

  render() {
    const tabIndex = this.props.onShow ? '0' : undefined;

    return (
      <div className="datepicker-months" style={{ display: 'block' }}>
        <table
          id="datepicker-months"
          className="table-condensed"
          aria-label="Please choose a month of the year"
          data-test-id="datepicker--months-grid"
        >
          <thead>
            <tr>
              <th
                className="prev"
                onClick={this.props.subtractYear}
                aria-label="Previous year"
                tabIndex={tabIndex}
                data-test-id="datepicker-prev--year"
              >
                ‹
              </th>

              <th
                className="switch"
                colSpan="5"
                onClick={this.props.showYears}
                aria-label="Change year"
                data-test-id="datepicker-show--years"
                tabIndex={tabIndex}
              >
                {this.props.viewDate.year()}
              </th>

              <th
                className="next"
                onClick={this.props.addYear}
                aria-label="Next year"
                tabIndex={tabIndex}
                data-test-id="datepicker-next--year"
              >
                ›
              </th>
            </tr>
          </thead>

          <tbody>
            <tr>
              <td colSpan="7">{this.renderMonths()}</td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }
}

DateTimePickerMonths.propTypes = {
  subtractYear: PropTypes.func.isRequired,
  addYear: PropTypes.func.isRequired,
  minDate: PropTypes.object,
  maxDate: PropTypes.object,
  onShow: PropTypes.bool.isRequired,
  viewDate: PropTypes.object.isRequired,
  selectedDate: PropTypes.object.isRequired,
  showYears: PropTypes.func.isRequired,
  setViewMonth: PropTypes.func.isRequired,
};
